import React from 'react';
import _ from 'lodash';
import { Link } from '@this/shared/ui/navigations/link';

import { withTheme } from 'styled-components';
import { Block } from './search_block/search_block.template';

import SearchBlock from './search_block/search_block';
import SearchTravelersBlock from './search_travelers_block/search_travelers_block';
import SearchPeoplenumBlock from './search_peoplenum_block/search_peoplenum_block.template';
import SearchHotelOptionBlock from './search_hotel_option_block/search_hotel_option_block.template';

import type { SearchTemplateProps } from './types';

const SearchMultipleLocationsTemplate: React.SFC<SearchTemplateProps> = ({
  query,
  user,
  handleChange,
  handleRemoveItem,
  addItemEnable,
  handleAddItem
}) => {
  return (
    <div>
      {query.items.map((item, i) => (
        <SearchBlock key={i} index={i} item={item} icon={i + 1} onRemoveItem={handleRemoveItem} />
      ))}

      <Block className="search__block">
        <div className="search__block__body">
          {!query.disabledTransitSearch && (
            <Link disabled={!addItemEnable} onClick={handleAddItem('transport')} style={{ marginRight: '10px' }}>
              +交通機関を追加
            </Link>
          )}
          {!query.disabledHotelSearch && (
            <Link disabled={!addItemEnable} onClick={handleAddItem('hotel')}>
              +ホテルを追加
            </Link>
          )}
        </div>
      </Block>
      {user ? (
        <SearchTravelersBlock query={query} user={user} handleChange={handleChange} />
      ) : (
        <SearchPeoplenumBlock query={query} handleChange={handleChange} />
      )}
      {!query.disabledHotelSearch && <SearchHotelOptionBlock query={query} handleChange={handleChange} />}
    </div>
  );
};

export default withTheme(SearchMultipleLocationsTemplate);
